import React from 'react';
import { useTranslation } from 'react-i18next';
import { TDR } from 'tdr-common';
import { getEventDisplayTitle } from '../../helpers/matchingEvents';
import { EVENT_ACCENT_BG_CLASSNAME, EVENT_ACCENT_TEXT_CLASSNAME } from './eventAccentStyles';

type EventSelectionBannerProps = {
	events: TDR.Event[];
};

/** Compact single-line "selected events" banner for the table-drawer footer. */
export function EventSelectionBanner({ events }: EventSelectionBannerProps) {
	const { t } = useTranslation();

	if (!events.length) {
		return null;
	}

	const eventNames = events.map(getEventDisplayTitle).join(', ');

	return (
		<div
			className={`border-b border-[#B58D45]/20 ${EVENT_ACCENT_BG_CLASSNAME} px-3 py-1.5 text-center -mt-2 w-[calc(100%+16px)] -ml-2 mb-1`}
			data-testid="event-booking-banner"
		>
			<p className={`font-poppins text-xs font-medium leading-tight ${EVENT_ACCENT_TEXT_CLASSNAME}`}>
				{t('labels.booking_event', {
					events: eventNames,
					defaultValue: `Selected events: ${eventNames}`
				})}
			</p>
		</div>
	);
}
